import {getSelectedAddressID} from '../selectors';
import getAddresses from './getAddresses';
import getEditedAddressIdList from './getEditedAddressIdList';

export default (state) => {
  const editedAddressIds = getEditedAddressIdList(state) || [];
  const selectedDeliveryId = getSelectedAddressID(state) || '';
  const addresses = getAddresses(state) || {};
  
  if (addresses && editedAddressIds && selectedDeliveryId) {
    return !!(editedAddressIds.includes(addresses[selectedDeliveryId]?.legacyId));
  }
  
  return false;
};
